import { render, staticRenderFns } from "./SelectBox4.vue?vue&type=template&id=767cb44c&scoped=true"
import script from "./SelectBox4.vue?vue&type=script&lang=js"
export * from "./SelectBox4.vue?vue&type=script&lang=js"
import style0 from "./SelectBox4.vue?vue&type=style&index=0&id=767cb44c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cb44c",
  null
  
)

export default component.exports